(function ($) {
  $(function () {});
})(jQuery);

(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    // Sticky shadow on scroll
    const nav = document.querySelector("#site-navigation");

    if (nav) {
      const onScroll = function () {
        nav.classList.toggle("is-scrolled", window.scrollY > 10);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll(); // run once on load in case page is pre-scrolled
    }

    // Site nav menu toggle
    const siteNavToggle = document.getElementById("site-nav-menu-toggle");

    // Mobile menu toggling
    for (const menuToggle of document.querySelectorAll(".menu-toggle")) {
      const menuContainer = document.getElementById(menuToggle.getAttribute("aria-controls"));

      if (menuContainer) {
        menuToggle.addEventListener("click", function (e) {
          toggleMenu(e.currentTarget);
        });
      }
    }

    const toggleMenu = function (triggerEl) {
      const isExpanded = triggerEl.getAttribute("aria-expanded") === "true";
      const menuContainer = document.getElementById(triggerEl.getAttribute("aria-controls"));

      // Other open menus (if expanding with current trigger)
      const expandedMenus = !isExpanded ? document.querySelectorAll(".menu-toggle[aria-expanded='true']") : [];

      const visibleExpandedMenus = Array.from(expandedMenus).filter((menu) => menu.checkVisibility());

      // Close any other open menus
      for (const menuToggleOpen of visibleExpandedMenus) {
        toggleMenu(menuToggleOpen);
      }

      if (menuContainer) {
        const transitionDuration = parseFloat(getComputedStyle(menuContainer).transitionDuration);

        triggerEl.setAttribute("aria-expanded", String(!isExpanded));
        menuContainer.classList.toggle("is-open", !isExpanded);
        menuContainer.style.transitionDelay = visibleExpandedMenus.length ? transitionDuration * 1.5 + "s" : null;
      }
    };

    const closeSubmenus = function () {
      document.querySelectorAll(".menu-item-has-children.is-open").forEach(function (el) {
        el.classList.remove("is-open");
        const toggle = el.querySelector(":scope > [aria-controls]");
        const sub = el.querySelector(":scope > .sub-menu");
        if (toggle) {
          toggle.setAttribute("aria-expanded", "false");
        }
        if (sub) {
          sub.classList.remove("is-open");
        }
      });
    };

    // Mobile sub-menu accordion
    document.querySelectorAll(".menu-item-has-children").forEach(function (item) {
      const sub = item.querySelector(":scope > .sub-menu");
      if (!sub) {
        return;
      }

      // Close opened sub-menus on mouseover other item
      item.addEventListener("mouseover", function (e) {
        // Only when siteNavToggle is not visible (indicating desktop vs mobile)
        if (!siteNavToggle.checkVisibility()) {
          closeSubmenus();
        }
      });

      const link = item.querySelector(":scope > a[aria-controls]");
      if (link) {
        // Button visibility managed in CSS
        const toggler = Object.assign(document.createElement("button"), {
          type: "button",
        });

        const label = link.dataset["toggleLabel"];
        if (label) {
          toggler.setAttribute("aria-label", label);
        }

        toggler.classList.add("sub-menu-toggle");
        toggler.setAttribute("aria-controls", link.getAttribute("aria-controls"));

        toggler.addEventListener("click", function (e) {
          e.stopPropagation();
          const open = item.classList.toggle("is-open");
          item.setAttribute("aria-expanded", String(open));
          sub.classList.toggle("is-open", open);
        });

        item.appendChild(toggler);
      }
    });

    // Search panel toggle
    const searchWrapper = document.querySelector(".nav-search");
    const searchToggle = document.querySelector(".nav-search__toggle");
    const searchPanel = document.getElementById("nav-search-form");
    const searchInput = searchPanel ? searchPanel.querySelector('.nav-search__input, input[type="search"]') : null;

    if (searchToggle && searchWrapper && searchPanel) {
      searchToggle.addEventListener("click", function (e) {
        e.stopPropagation();
        const isOpen = searchWrapper.classList.toggle("is-open");

        searchToggle.setAttribute("aria-expanded", String(isOpen));
        searchPanel.setAttribute("aria-hidden", String(!isOpen));

        if (isOpen && searchInput) {
          // Small delay lets the CSS transition finish before focusing
          setTimeout(function () {
            searchInput.focus();
          }, 220);
        }
      });
    }

    // Close on outside click
    document.addEventListener("click", function (e) {
      // Close desktop dropdowns
      if (!e.target.closest(".menu-item-has-children")) {
        closeSubmenus();
      }

      // Close search panel
      if (searchWrapper && searchWrapper.classList.contains("is-open") && !e.target.closest(".nav-search")) {
        searchWrapper.classList.remove("is-open");
        if (searchToggle) {
          searchToggle.setAttribute("aria-expanded", "false");
        }
        if (searchPanel) {
          searchPanel.setAttribute("aria-hidden", "true");
        }
      }
    });

    // Keyboard navigation
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") {
        return;
      }

      // Close any open dropdown and return focus to its parent link
      const openItem = document.querySelector(".menu-item-has-children.is-open");
      if (openItem) {
        openItem.classList.remove("is-open");
        const toggle = openItem.querySelector(":scope > a[aria-controls]");
        const sub = openItem.querySelector(":scope > .sub-menu");
        if (toggle) {
          toggle.setAttribute("aria-expanded", "false").focus();
        }
        if (sub) {
          sub.classList.remove("is-open");
        }
      }

      // Close search panel and return focus to toggle button
      if (searchWrapper && searchWrapper.classList.contains("is-open")) {
        searchWrapper.classList.remove("is-open");
        if (searchToggle) {
          searchToggle.setAttribute("aria-expanded", "false");
          searchToggle.focus();
        }
        if (searchPanel) {
          searchPanel.setAttribute("aria-hidden", "true");
        }
      }

      // Close mobile menu
      if (menuContainer && menuContainer.classList.contains("is-open")) {
        menuContainer.classList.remove("is-open");
        if (menuToggle) {
          menuToggle.setAttribute("aria-expanded", "false");
          menuToggle.focus();
        }
      }
    });
  }); // DOMContentLoaded

  // Back-to-top button
  // Runs outside DOMContentLoaded so the scroll listener registers early; safe because the script is footer-deferred.
  const backToTop = document.getElementById("back-to-top");

  if (backToTop) {
    const SCROLL_THRESHOLD = 400; // px before button appears

    const toggleBackToTop = function () {
      const visible = window.scrollY > SCROLL_THRESHOLD;
      backToTop.classList.toggle("is-visible", visible);
      backToTop.setAttribute("tabindex", visible ? "0" : "-1");
      backToTop.setAttribute("aria-hidden", String(!visible));
    };

    window.addEventListener("scroll", toggleBackToTop, { passive: true });
    toggleBackToTop(); // run once on load

    backToTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
      // Return focus to first focusable element at top of page
      const skipLink = document.querySelector(".skip-link");
      if (skipLink) {
        skipLink.focus();
      }
    });
  }
})();

window.onload = (event) => {
  moveDiv(".Cards--grid .SSCMGrid-grid_item_wrapper");
};

function moveDiv(mainElement) {
  var all = document.querySelectorAll(mainElement);

  for (let i = 0; i < all.length; i++) {
    var divToMove = all[i].children[0].childNodes[5];
    if (!divToMove) {
      continue;
    }

    var destinationContainer = all[i].children[0].childNodes[2];
    destinationContainer.appendChild(divToMove);
  }
}

// Cards
jQuery(document).ready(function() {
    if (jQuery('.fl-builder-edit').length > 0) {
        
    }else{
        if (jQuery(".card--item")[0]){
          jQuery('.card--item').each(function(index, element) {
            var button = jQuery(this).find('.fl-button').first();
            var href = button.attr('href');

            if (!href) {
              return;
            }

            var cardLink = jQuery('<a class="card--link"></a>').attr('href', href);

            if (button.attr('target')) {
              cardLink.attr('target', button.attr('target'));
            }
            if (button.attr('rel')) {
              cardLink.attr('rel', button.attr('rel'));
            }

            jQuery('.fl-col-content', this).wrapInner(cardLink);
          });
        }
        if ( jQuery(".HoverBox")[0] ){
          jQuery('.HoverBox .fl-col-has-cols > .fl-col-content').each(function(index, element) {
              var targetElement = jQuery(this).find('.fl-button ').attr('href');
              jQuery( this ).append( "<a href='"+targetElement+"' target='_self' class='HoverBox--link'></a>" );
          });
        }
    }

});
